import {
  Col,
  Container,
  FormGroup,
  FormLabel,
  FormSelect,
  Row,
} from "react-bootstrap";
import React, { useEffect } from "react";

import DOMPurify from "isomorphic-dompurify";
import axios from "axios";
import { marked } from "marked";
import { useParams } from "react-router-dom";
import { useState } from "react";

const AdminChatHistory = () => {
  const { id, bot } = useParams();
  const [name, setName] = useState();
  const [color, setColor] = useState("#808080");
  const [headerColor, setheaderColor] = useState("#416cbe");
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const [messages, setMessage] = useState([]);
  const [daysAgo, setDaysAgo] = useState(10);
  const [isFirst, setIsFirst] = useState(true);
  const today = new Date();
  const [loadedMessages, setLoadedMessages] = useState(10); // Number of messages currently loaded
  const [totalMessages, setTotalMessages] = useState(0); // Total number of messages available

  const calculateDate = new Date();
  calculateDate.setDate(today.getDate() - daysAgo);
  const noHistory = "There is no history yet to show.";
  const [sessionSelectedId, setSessionSelectedId] = useState();
  const [messageList, setMessageList] = useState([]);
  const [sessionList, setSessionList] = useState([]);

  const fetchSessionData = (selectedId) => {
    // Fetch session data based on the selected session ID
    axios
      .get(`${API_URL}/${API_VERSION}/bot/session-msg/${bot}/${selectedId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        const msg = response.data[0].messages.map((msg) => msg);
        setMessageList(msg);
      })
      .catch((err) => {
      });
  };

  const handlerChange = (event) => {
    const selectedId = event.target.value;
    setSessionSelectedId(selectedId);
    // Fetch session data for the selected session
    fetchSessionData(selectedId);
  };

  useEffect(() => {
    if (isFirst) {
      setIsFirst(false);
      if (localStorage.getItem("isRole") === "admin") {
        setDaysAgo(30);
      }
      axios
        .get(`${API_URL}/${API_VERSION}/bot/${bot}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setColor(response.data.chatInterface.color);
          setheaderColor(response.data.chatInterface.headerColor);
          setName(response.data.name);
        })
        .catch((err) => {
          console.log(err);
        });
      axios
        .get(`${API_URL}/${API_VERSION}/bot/chatHistory/${bot}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          const msg = response.data.messages.map((msg) => msg);
          setMessage(msg);
        })
        .catch((err) => {
          console.log(err);
        });
      axios
        .get(`${API_URL}/${API_VERSION}/bot/message-session/${bot}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setSessionList(response.data);

          if (response.data.length > 0) {
            setSessionSelectedId(response.data[0].session_id);
            fetchSessionData(response.data[0].session_id);
          }
          //setLoading(false);
        })
        .catch((err) => {
          // console.log(err);
          //setLoading(false);
        });
    }
  }, [API_URL, API_VERSION, id, isFirst]);
  const loadMoreMessages = () => {
    setLoadedMessages((prevCount) => prevCount + 10); // Increment the number of loaded messages by 10
  };
  useEffect(() => {
    setTotalMessages(messageList.length);
  }, [messageList]);
  const hasMoreMessages = totalMessages > loadedMessages;

  const startIndex = Math.max(totalMessages - loadedMessages, 0);

  const messagesToShow = messageList.slice(startIndex);

  return (
    <>
      <section className="chating_box">
        <Container>
          <Row className="justify-content-center mt-3">
            <Col md={12}>
              <FormGroup className="mb-3">
                <FormLabel>Select Session ID</FormLabel>
                <FormSelect
                  type="text"
                  value={sessionSelectedId}
                  onChange={handlerChange}
                >
                  {sessionList.map((id) => (
                    <option value={id.session_id} key={id.session_id}>
                      {id.session_id} -{" "}
                      {new Date(id.createdAt).toLocaleString()}
                    </option>
                  ))}
                </FormSelect>
              </FormGroup>
            </Col>
            <Col md={12}>
              <div className="chatingwrap">
                <div
                  className="chating_head"
                  style={{ background: headerColor }}
                >
                  <div className="brand">
                    <span>{name}</span>
                  </div>
                  <div className="refresh">
                    <i className="fa-solid fa-rotate"></i>
                  </div>
                </div>
                <div className="chating_area">
                  {hasMoreMessages && (
                    <div className="text-center mt-3">
                        <button href="#" className="load_btn" style={{ background: headerColor }}  onClick={loadMoreMessages}>
                          Load More
                        </button>
                    </div>
                  )}
                  {messages.length === 0 ? (
                    <ul>
                      <li className="sender">
                        <div className="cont">
                          <span>{noHistory}</span>
                        </div>
                      </li>
                    </ul>
                  ) : (
                    ""
                  )}
                  {messagesToShow.map((msg, index) => {
                    if (msg.data !== null) {
                      return (
                        <ul key={msg.id}>
                          <li
                            className={
                              msg.from === "user" ? "repaly" : "sender"
                            }
                            style={
                              msg.from === "user" ? { background: color } : {}
                            }
                          >
                            <div className="cont">
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: DOMPurify.sanitize(
                                    marked.parse(msg.data.text)
                                  ),
                                }}
                              ></span>
                            </div>
                          </li>
                        </ul>
                      );
                    } else {
                      return null;
                    }
                  })}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default AdminChatHistory;
